import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import moment from "moment";

function formatCountdown(totalSeconds) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return [h, m, sec].map((n) => String(n).padStart(2, "0")).join(":");
}

function formatKolkata(value) {
  if (!value) return "";
  const m = moment.parseZone(value);
  if (!m.isValid()) return "";
  return m.utcOffset(330).format("DD MMM YYYY, h:mm A");
}

export default function ResponseWindowCard({ responseWindow, onExpired }) {
  const onExpiredRef = useRef(onExpired);
  onExpiredRef.current = onExpired;

  const initialRemaining = Number(responseWindow?.remainingSeconds) || 0;
  const initiallyExpired =
    responseWindow?.isExpired === true || initialRemaining <= 0;

  const [remaining, setRemaining] = useState(
    initiallyExpired ? 0 : initialRemaining,
  );
  const [expired, setExpired] = useState(initiallyExpired);

  useEffect(() => {
    const rem = Number(responseWindow?.remainingSeconds) || 0;
    const isExp = responseWindow?.isExpired === true || rem <= 0;
    setRemaining(isExp ? 0 : rem);
    setExpired(isExp);
  }, [
    responseWindow?.remainingSeconds,
    responseWindow?.isExpired,
    responseWindow?.expiresAt,
    responseWindow?.lastIncomingAt,
  ]);

  useEffect(() => {
    if (expired) return undefined;

    const timer = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          setExpired(true);
          if (typeof onExpiredRef.current === "function") {
            onExpiredRef.current();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [expired, responseWindow?.expiresAt]);

  const expiresAtLabel = formatKolkata(responseWindow?.expiresAt);

  return (
    <section className="wa-crm-section wa-crm-response">
      <div className="wa-crm-section-title">
        <Icon
          icon="solar:clock-circle-bold"
          width={20}
          className="wa-crm-title-icon-teal"
        />
        <span>Response Window</span>
      </div>

      <div className={`wa-crm-window-box ${expired ? "is-expired" : "is-active"}`}>
        <p className="wa-crm-window-help">
          You can reply only within 24 hours of the user&apos;s last message.
        </p>

        {expired ? (
          <div className="wa-crm-expired-box">
            <Icon icon="solar:danger-triangle-bold" width={18} />
            <span>Expired</span>
          </div>
        ) : (
          <div className="wa-crm-active-box">
            <Icon icon="solar:check-circle-bold" width={18} />
            <span>Active</span>
            <span className="wa-crm-countdown">{formatCountdown(remaining)}</span>
          </div>
        )}

        {expiresAtLabel ? (
          <p className="wa-crm-window-meta">
            Expires: {expiresAtLabel} (IST)
          </p>
        ) : null}
      </div>
    </section>
  );
}
